import { Text } from "@overmap-ai/blocks"
import { type User } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { memo } from "react"

import { useAppSelector } from "../../../../store"
import { getUserDisplayLabel } from "../../../../utils/users"

export const UserMentionComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const { id } = node.attrs as { id: User["id"] }

	const user = useAppSelector(selectUserById(id))

	return (
		<NodeViewWrapper
			className="bg-(--base-a3) py-0.25 inset-ring inset-ring-(--base-a6) rounded-md px-1 align-bottom"
			as="span"
		>
			{!!user && <Text className="truncate">{getUserDisplayLabel(user)}</Text>}
		</NodeViewWrapper>
	)
})
UserMentionComponent.displayName = "UserMentionComponent"
